import Vue from 'vue';
import Router from 'vue-router';

/* layout */
import Layout from '../components/Layout.vue';

/* dashboard */
import Dashboard from '../views/dashboard/index.vue';
import Notice from '../views/dashboard/notice.vue';
import NoticeDetail from '../views/dashboard/noticeDetail.vue';
// import UserInfo1 from '../views/dashboard/userInfo.vue';

/* error page */
import Err404 from '../views/404.vue';

/* demo */
import BreadCumb from '../views/demo/breadCumb.vue';
import DemoForm from '../views/demo/form.vue';
import DemoTable from '../views/demo/table.vue';
import DemoDialog from '../views/demo/dialog.vue';
import DemoAmap from '../views/demo/amap.vue';
import DemoCropper from '../views/demo/cropper.vue';
import DemoDraggable from '../views/demo/draggable.vue';
import DemoEcharts from '../views/demo/echarts.vue';

import BasicCooperationInfo from '../views/basic/cooperationInfo.vue';
import BasicFinanceInfo from '../views/basic/financeInfo.vue';

/* passport */
import Login from '../views/passport/login.vue';
import ChangePassword from '../views/passport/changePassword.vue';
import Account from '../views/passport/account.vue';

/*系统配置*/
/*user*/
import UserList from '../views/system/user/list.vue';
import AddUser from '../views/system/user/add.vue';
import EditUser from '../views/system/user/edit.vue';
import RelatedGroup from '../views/system/user/relatedGroup.vue';

/*notice*/
import NoticeList from '../views/system/notice/list.vue';
import AddNotice from '../views/system/notice/add.vue';

/*report*/
import ReportOrderInfo from '../views/report/commercial/order.vue';
import ReportTrade from '../views/report/trade.vue';
import ReportDinner from '../views/report/dinner.vue';
import ReportSettle from '../views/report/settle.vue';
import ReportSchool from '../views/report/school.vue';
import ReportSchool1 from '../views/report/school1.vue';
import ReportHistoryData from '../views/report/historyData.vue';

import FinanceMerchant from '../views/finance/merchant.vue';
import FinanceShop from '../views/finance/shop.vue';
import FinancePay from '../views/finance/pay.vue';
import FinanceTransaction from '../views/finance/transaction.vue';
import FinancePayList from '../views/finance/payList.vue';
import FinanceSchoolBill from '../views/finance/schoolBill.vue';
import FinanceSchoolTotalBill from '../views/finance/schoolTotalBill.vue';
import FinanceSchoolTotalBill1 from '../views/finance/schoolTotalBill1.vue';
import FinanceSchoolTotalBill2 from '../views/finance/schoolTotalBill2.vue';
import FinanceSchoolTotalBill3 from '../views/finance/schoolTotalBill3.vue';
import FinanceSchoolTotalBill4 from '../views/finance/schoolTotalBill4.vue';
import FinanceSchoolTotalBill5 from '../views/finance/schoolTotalBill5.vue';


import EstimateList from '../views/aftersale/estimate/list.vue';
import ComplaintList from '../views/aftersale/complaint/list.vue';
import ActivityList from '../views/activity/list.vue';
import ActivityDetail from '../views/activity/activityDetail.vue';
import JoinDetail from '../views/activity/joinDetail.vue';
import ActivityForm from '../views/activity/activityForm.vue';
import CommentList from '../views/activity/comment.vue';
import RefundList from '../views/aftersale/refund/list.vue';
import Dining from '../views/dining/info.vue';

/** 总对总 */
import HeadDashboard from '../views/headOffice/home.vue';
import ShopList from '../views/headOffice/shop/list.vue';
import GoodsList from '../views/headOffice/goods/list.vue';
import FlowList from '../views/headOffice/business/flow/list.vue';
import OrderList from '../views/headOffice/business/order/list.vue';
import Download from '../views/headOffice/business/download/list.vue';

/** 代理商 */
import BasicShopInfo from '../views/saas/basic/shopInfo.vue';
import BasicBindKq from '../views/saas/basic/bindKq.vue';
import SaasShopData from '../views/saas/shopData.vue';
import SaasOrderData from '../views/saas/orderData.vue';
import SaasPaymentProgress from '../views/saas/payment.vue';

Vue.use(Router);

// 配置路由

const constantRouterMap = [
    //passport
    {
        path: '/passport/login',
        component: Login,
        name: 'login',
        hidden: true
    },
    {
        path: '/passport',
        component: Layout,
        redirect: 'noredirect',
        name: 'changepwd',
        hidden: true,
        children: [{ path: 'changepwd', component: ChangePassword }]
    },
    {
        path: '/passport',
        component: Layout,
        redirect: 'noredirect',
        name: 'account',
        hidden: true,
        children: [{ path: 'account', component: Account }]
    },
    {
        path: '*',
        name: '404',
        component: Err404,
        hidden: true
    },
    // 学校首页
    {
        path: '/school',
        component: Layout,
        name: 'SchoolHome',
        hidden: true,
        children: [{ path: 'home', component: Dashboard }]
    },
    // 数据首页
    {
        path: '/dashboard',
        component: Layout,
        name: 'Home',
        hidden: true,
        children: [{ path: '', component: HeadDashboard }]
    }
]

export const systemRouterMap = [
    {
        path: '/',
        component: Layout,
        redirect: '/school/home',
        name: 'Home',
        children: [{ path: 'home', component: Dashboard }]
    },
    {
        path: '/basic',
        component: Layout,
        redirect: 'noredirect',
        //name: 'userList',
        children: [
            { path: 'cooperation/info/:ruleId', component: BasicCooperationInfo, name: 'basicCooperationInfo'},
            { path: 'finance/info/:ruleId', component: BasicFinanceInfo, name: 'basicFinanceInfo'},
        ]
    },
    {
        path: '/report',
        component: Layout,
        redirect: 'noredirect',
        children: [
            { path: 'orderInfo/:ruleId', component: ReportOrderInfo, name: 'reportOrderInfo'},
            { path: 'trade/:ruleId', component: ReportTrade, name: 'ReportTrade'},
            { path: 'dinner/:ruleId', component: ReportDinner, name: 'ReportDinner'},
            { path: 'settle/:ruleId', component: ReportSettle, name: 'ReportSettle'},
            { path: 'school/:ruleId', component: ReportSchool, name: 'School'}, // 上师大专用报表
            { path: 'school1/:ruleId', component: ReportSchool1, name: 'School1'}, // 上大专用报表
            { path: 'history/data/:ruleId', component: ReportHistoryData, name: 'ReportHistoryData'}
        ]
    },
    {
        path: '/finance',
        component: Layout,
        redirect: 'noredirect',
        children: [
            { path: 'merchant/bill/:ruleId', component: FinanceMerchant, name: 'financeMerchant'},
            { path: 'merchant/bill/:vid/:ruleId', component: FinanceMerchant, name: 'financeMerchantV2'},
            { path: 'shop/bill/:ruleId', component: FinanceShop, name: 'financeShop'},
            { path: 'pay/bill/:ruleId', component: FinancePay, name: 'financePay'},
            { path: 'transaction/bill/:ruleId', component: FinanceTransaction, name: 'financeTransaction'},
            { path: 'payList/bill/:ruleId', component: FinancePayList, name: 'FinancePayList'},
            { path: 'school/bill/:ruleId', component: FinanceSchoolBill, name: 'FinanceSchoolBill'},
            { path: 'school/total/bill/:ruleId', component: FinanceSchoolTotalBill, name: 'FinanceSchoolTotalBill'},
            { path: 'school/total/bill1/:ruleId', component: FinanceSchoolTotalBill1, name: 'FinanceSchoolTotalBillV1'},
            { path: 'school/total/bill2/:ruleId', component: FinanceSchoolTotalBill2, name: 'FinanceSchoolTotalBillV2'},
            { path: 'school/total/bill3/:ruleId', component: FinanceSchoolTotalBill3, name: 'FinanceSchoolTotalBillV3'},
            { path: 'school/total/bill4/:ruleId', component: FinanceSchoolTotalBill4, name: 'FinanceSchoolTotalBillV4'},
            { path: 'school/total/bill5/:ruleId', component: FinanceSchoolTotalBill5, name: 'FinanceSchoolTotalBillV5'},
        ]
    },
    {
        path: '/aftersale',
        component: Layout,
        redirect: 'noredirect',
        children: [
            { path: 'estimate/list/:ruleId', component: EstimateList, name: 'estimateList'},
            { path: 'complaint/list/:ruleId', component: ComplaintList, name: 'complaintList'},
            { path: 'refund/list/:ruleId', component: RefundList, name: 'refundList'},
        ]
    },
    {
        path: '/dining',
        component: Layout,
        redirect: 'noredirect',
        name: 'info',
        hidden: true,
        children: [{ path: 'info', component: Dining }]
    },
    {
        path: '/activity',
        component: Layout,
        redirect: 'noredirect',
        children: [
            { path: 'list/:ruleId', component: ActivityList },
            { path: 'detail/:ruleId', component: ActivityDetail },
            { path: 'edit/:ruleId', component: ActivityForm },
            { path: 'join/:ruleId', component: JoinDetail },
            { path: 'comment/:ruleId', component: CommentList },
        ]
    },
]

/*总对总*/
export const headOfficeRouterMap = [
    {
        path: '/',
        component: Layout,
        redirect: '/dashboard',
        name: 'Home',
        children: [{ path: 'dashboard', component: HeadDashboard }]
    },
    {
        path: '/shop',
        component: Layout,
        children: [{ path: 'list', component: ShopList }],
    },
    {
        path: '/goods',
        component: Layout,
        children: [{ path: 'list', component: GoodsList }],
    },
    {
        path: '/business',
        component: Layout,
        children: [
            { path: 'flow/:rule_id', component: FlowList },
            { path: 'order/:rule_id', component: OrderList },
            { path: 'download/:rule_id', component: Download },
        ],
    },
]

/*代理商*/
export const saasRouterMap = [
    {
        path: '/',
        component: Layout,
        redirect: '/saas/shop/info',
        name: 'Home',
        children: [{ path: 'info', component: BasicShopInfo }]
    },
    {
        path: '/saas',
        component: Layout,
        name: 'Home',
        children: [
            { path: 'shop/info', component: BasicShopInfo },
            { path: 'kq/bind/:id/:sid/:status', component: BasicBindKq },
            { path: 'shop/data', component: SaasShopData },
            { path: 'order/data', component: SaasOrderData, name: 'SaasOrderData' },
            { path: 'payment/progress', component: SaasPaymentProgress }
        ]
    }
]

const createRouter = () => new Router({
    mode: 'history',
    scrollBehavior: () => ({ y: 0 }),
    routes: constantRouterMap,
})

const router = createRouter()

router.$addRoutes = (routes) => {
    console.log('routes', routes)
    router.matcher = createRouter().matcher
    router.addRoutes(routes);
}

if (localStorage.getItem('type') == 4) {
    // 总对总菜单
    router.$addRoutes(headOfficeRouterMap);
} else if (localStorage.getItem('type') == 5) {
    // 代理商
    router.$addRoutes(saasRouterMap);
} else {
    router.$addRoutes(systemRouterMap);
}

export default router;




// WEBPACK FOOTER //
// ./vue/config/routes.js